<template>
  <v-row justify="center">
    <slot></slot>
    <v-dialog scrollable max-width="400px" v-model="showDialog">
      <template v-slot:activator="{ on }">
        <v-btn
          :disabled="disabled"
          color="primary"
          fab
          outlined
          :small="small"
          v-on="on"
          :loading="loading"
          ><v-icon :small="small" :left="iconLeft" :right="iconRight">{{
            icon
          }}</v-icon
          >{{ boton }}</v-btn
        >
      </template>
      <v-card>
        <v-card-title>{{ titulo }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="my-5">
          <h4>{{ texto }}</h4>
        </v-card-text>
        <v-card-actions>
          <v-btn big color="primary" outlined @click="clicked('NO')">NO</v-btn>
          <v-spacer></v-spacer>
          <v-btn big color="primary" outlined @click="clicked('SI')">SI</v-btn>
        </v-card-actions>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {

  props: {
    titulo: { type: String, default: "Confirmar" },
    texto: { type: String, default: "¿Esta seguro de continuar?" },
    boton: { type: String, default: "Confirmar" },
    small: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    icon: { type: String, default: "" },
    iconLeft: { type: Boolean, default: false },
    iconRight: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    clicked(valor) {
      if (valor == "SI") {
        this.$emit("si");
      } else {
        this.$emit("no");
      }
      this.showDialog = false;
    }
  }
};
</script>
